import { CheckIcon } from 'lucide-react';

import { Flex } from 'components/layout';
import {
  Timeline,
  TimelineContent,
  TimelineHeader,
  TimelineIndicator,
  TimelineItem,
  TimelineSeparator,
  TimelineTitle,
} from 'components/reui/timeline';

import { CalculationStep } from '../types';

type CalculationStepsProps = {
  steps: CalculationStep[];
};

export function CalculationSteps({ steps }: CalculationStepsProps) {
  return (
    <Timeline defaultValue={steps.length} className='w-full my-2'>
      {steps.map((step, index) => {
        const stepNumber = index + 1;

        return (
          <TimelineItem
            key={step.id}
            step={stepNumber}
            className='group-data-[orientation=vertical]/timeline:ms-10 group-data-[orientation=vertical]/timeline:not-last:pb-4'
          >
            <TimelineHeader>
              <TimelineSeparator className='!bg-brand border-brand group-data-[orientation=vertical]/timeline:-left-7 group-data-[orientation=vertical]/timeline:h-[calc(100%-1.5rem-0.25rem)] group-data-[orientation=vertical]/timeline:translate-y-6' />
              <TimelineTitle className='-mt-0.5 font-medium text-neutral-900 text-[12px]'>
                {step.title}
              </TimelineTitle>
              <TimelineIndicator className='size-4.5 border-none bg-brand text-neutral-50 group-data-[orientation=vertical]/timeline:-left-7'>
                <Flex align='center' justify='center' className='size-full'>
                  <CheckIcon className='h-3 w-3 !stroke-neutral-50' />
                </Flex>
              </TimelineIndicator>
            </TimelineHeader>
            <TimelineContent className='text-[10px] leading-4 text-neutral-600'>
              {step.description}
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
}
